import styled from 'styled-components';

const FooterStyle = styled.footer`
	--fPadTop: var(--sp30x);
	--fPadTBot: var(--sp13x);
	--formMTop: var(--sp13x);
	--formItemDistance: var(--sp9x);
	--fMenuMTop: var(--sp18x);
	--fMenuItemDistance: var(--sp18x);
	--ftSocialsMTop: var(--sp13x);
	--ftSocialsIconsDistance: var(--sp8x);
	--ftBotWrapMTop: var(--sp13x);
	--fLogoWidth: var(--sp24x);
	--fLogoHeight: var(--sp11x);
	--formBtnMTop: var(--sp9x);
	--backgroundMapDistance: var(--sp14x);
	--successPadTB: var(--sp12x);
	--mDescMTop: var(--sp3x);

	padding-top: var(--fPadTop);
	padding-bottom: var(--fPadTBot);
	z-index: 3;

	.form-container {
		margin-top: var(--formMTop);

		.if-item {
			&:nth-child(n + 3) {
				margin-top: var(--formItemDistance);
			}
		}

		.form-btn-wrap {
			display: flex;
			justify-content: center;
			margin-top: var(--formBtnMTop);
		}

		.message-mt {
			margin-top: var(--formItemDistance);
		}

		.row {
			position: relative;
		}

		//! Success message styles
		.success-message-wrapper {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			padding: var(--successPadTB) 0;

			.m-description {
				margin-top: var(--mDescMTop);
			}

			.sm-line {
				position: absolute;
				left: 0;
				right: 0;

				&.top {
					top: 0;
					border-top: 1px solid var(--primaryColor9);
				}

				&.bottom {
					bottom: 0;
					border-bottom: 1px solid var(--primaryColor9);
				}
			}
		}
	}

	.f-menu-container {
		margin-top: calc(var(--fMenuMTop) + var(--sp4x));

		.fm-items-wrap {
			display: flex;
			justify-content: center;
			flex-wrap: wrap;

			.f-menu-item {
				margin: 0 calc(var(--fMenuItemDistance) / 2);
			}
		}
	}

	.ft-socials-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: var(--ftSocialsMTop);

		i {
			line-height: 1 !important;

			&:before {
				color: var(--primaryColor9);
			}

			@media (hover: hover) {
				&:hover {
					&:before {
						color: var(--primaryColor11);
					}
				}
			}
		}

		.icon-wrap {
			margin: 0 calc(var(--ftSocialsIconsDistance) / 2);
		}
	}

	.ft-bottom-wrapper {
		margin-top: var(--ftBotWrapMTop);

		.fl-wrap {
			display: flex;
			align-items: center;

			.ft-company-wrapper {
				flex: 1;
			}

			.f-logo-wrapper {
				width: var(--fLogoWidth);
				margin: 0 calc(var(--colPadding) / 2);

				.image-cont {
					padding-top: var(--fLogoHeight);
					background-color: transparent !important;
				}
			}

			.concept-studio-wrapper {
				flex: 1;
				display: flex;
				justify-content: flex-end;

				.link-item {
					@media (hover: hover) {
						&:hover {
							color: var(--primaryColor11);
						}
					}
				}
			}
		}
	}

	.footer-anim-bg {
		position: absolute;
		inset: 0;
		overflow: hidden;
		z-index: -1;
		margin-top: calc(var(--fPadTop) + var(--backgroundMapDistance));

		.global-wrap {
			position: relative;
			width: 100%;
			height: 100%;

			.circle-wrapper {
				position: absolute;
				width: 153vw;
				height: 47vw;
				left: 50%;
				transform: translateX(-50%);
				border-radius: 50%;
				background-color: var(--primaryColor1);
			}
		}
	}

	.footer-fake-bg {
		position: absolute;
		top: calc(var(--fPadTop) * 3);
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--primaryColor1);
		z-index: -1;
	}

	&:not(.no-distributor) {
		.ds-container {
			.ds-title {
				transform: translate3d(0, -30%, 0);
			}

			.ds-map-wrapper {
				transform: translate3d(0, 40%, 0);
			}
		}
	}

	&.no-distributor {
		margin-top: var(--sectionDistance);

		.running-text {
			transform: translate3d(0, -10%, 0);
		}

		.form-container {
			transform: translate3d(0, 7%, 0);
		}

		.footer-anim-bg {
			margin-top: 0 !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--fPadTop: var(--sp25x);
		--fPadTBot: var(--sp10x);
		--formMTop: var(--sp12x);
		--formItemDistance: var(--sp8x);
		--fMenuMTop: var(--sp16x);
		--fMenuItemDistance: var(--sp15x);
		--ftSocialsMTop: var(--sp10x);
		--ftSocialsIconsDistance: var(--sp5x);
		--ftBotWrapMTop: var(--sp10x);
		--fLogoWidth: var(--sp17x);
		--fLogoHeight: var(--sp8x);
		--formBtnMTop: var(--sp7x);
		--backgroundMapDistance: var(--sp11x);

		--successPadTB: var(--sp12x);
		--mDescMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--fPadTop: var(--sp20x);
		--fPadTBot: var(--sp8x);
		--formMTop: var(--sp8x);
		--formItemDistance: var(--sp5x);
		--fMenuMTop: var(--sp13x);
		--fMenuItemDistance: var(--sp11x);
		--ftSocialsMTop: var(--sp8x);
		--ftSocialsIconsDistance: var(--sp5x);
		--ftBotWrapMTop: var(--sp8x);
		--fLogoWidth: var(--sp17x);
		--fLogoHeight: var(--sp8x);
		--formBtnMTop: var(--sp6x);
		--backgroundMapDistance: var(--sp9x);

		--successPadTB: calc(var(--sp18x) / 2);
		--mDescMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--fPadTop: var(--sp19x);
		--fPadTBot: var(--sp8x);
		--formMTop: var(--sp7x);
		--formItemDistance: var(--sp5x);
		--fMenuMTop: var(--sp11x);
		--fMenuItemDistance: var(--sp11x);
		--ftSocialsMTop: var(--sp8x);
		--ftSocialsIconsDistance: var(--sp5x);
		--ftBotWrapMTop: var(--sp8x);
		--fLogoWidth: var(--sp17x);
		--fLogoHeight: var(--sp8x);
		--formBtnMTop: var(--sp6x);
		--backgroundMapDistance: var(--sp8x);

		--successPadTB: calc(var(--sp18x) / 2);
		--mDescMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--fPadTop: var(--sp20x);
		--fPadTBot: var(--sp7x);
		--formMTop: var(--sp7x);
		--formItemDistance: var(--sp5x);
		--fMenuMTop: var(--sp12x);
		--fMenuItemDistance: var(--sp8x);
		--ftSocialsMTop: var(--sp7x);
		--ftSocialsIconsDistance: var(--sp5x);
		--ftBotWrapMTop: var(--sp7x);
		--fLogoWidth: var(--sp17x);
		--fLogoHeight: var(--sp8x);
		--formBtnMTop: var(--sp5x);
		--backgroundMapDistance: var(--sp7x);

		--successPadTB: var(--sp9x);
		--mDescMTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--fPadTop: var(--sp21x);
		--fPadTBot: var(--sp7x);
		--formMTop: var(--sp6x);
		--formItemDistance: var(--sp5x);
		--fMenuMTop: var(--sp9x);
		--fMenuItemDistance: var(--sp4x);
		--ftSocialsMTop: var(--sp7x);
		--ftSocialsIconsDistance: var(--sp5x);
		--ftBotWrapMTop: var(--sp7x);
		--fLogoWidth: var(--sp17x);
		--fLogoHeight: var(--sp8x);
		--formBtnMTop: var(--sp5x);
		--backgroundMapDistance: var(--sp6x);

		--successPadTB: calc(var(--sp21x) / 2);
		--mDescMTop: var(--sp2x);

		.ft-bottom-wrapper .fl-wrap .f-logo-wrapper {
			margin: 0 var(--sp14x);
		}

		.f-menu-container .fm-items-wrap .f-menu-item {
			&:first-child {
				margin-left: 0;
			}

			&:last-child {
				margin-right: 0;
			}
		}

		.footer-fake-bg {
			top: calc(var(--fPadTop) * 2) !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--fPadTop: var(--sp18x);
		--fPadTBot: var(--sp7x);
		--formMTop: var(--sp8x);
		--formItemDistance: var(--sp4x);
		--fMenuMTop: var(--sp8x);
		--fMenuItemDistance: var(--sp4x);
		--ftSocialsMTop: var(--sp4x); /** //! For menu items in languages case */
		--ftSocialsIconsDistance: var(--sp5x);
		--ftBotWrapMTop: var(--sp7x);
		--fLogoWidth: var(--sp13x);
		--fLogoHeight: var(--sp6x);
		--formBtnMTop: var(--sp5x);
		--backgroundMapDistance: var(--sp6x);

		--successPadTB: calc(var(--sp21x) / 2);
		--mDescMTop: var(--sp2x);

		.ft-bottom-wrapper .fl-wrap .f-logo-wrapper {
			margin: 0 var(--sp6x);
		}

		.f-menu-container .fm-items-wrap .f-menu-item {
			margin-bottom: var(--sp3x);
		}

		.footer-fake-bg {
			top: calc(var(--fPadTop) * 2) !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--fPadTop: var(--sp8x);
		--fPadTBot: var(--sp5x);
		--formMTop: var(--sp5x);
		--formItemDistance: var(--sp4x);
		--fMenuMTop: var(--sp7x);
		--fMenuItemDistance: var(--sp3x);
		--ftSocialsMTop: var(--sp4x); /** //! For menu items in languages case */
		--ftSocialsIconsDistance: var(--sp5x);
		--ftBotWrapMTop: var(--sp7x);
		--fLogoWidth: var(--sp13x);
		--fLogoHeight: var(--sp6x);
		--formBtnMTop: var(--sp4x);
		--backgroundMapDistance: var(--sp5x);

		--successPadTB: var(--sp21x);
		--mDescMTop: var(--sp2x);

		.form-container {
			.if-item {
				&:nth-child(n + 2) {
					margin-top: var(--formItemDistance);
				}
			}
		}

		.ft-bottom-wrapper {
			.mobile-logo-wrap {
				display: flex;
				justify-content: center;
				pointer-events: none;

				.image-cont {
					width: var(--fLogoWidth);
					padding-top: var(--fLogoHeight);
					pointer-events: all;
				}
			}

			.company-name-mobile {
				margin-top: var(--sp5x);
			}

			.concept-studio-mobile {
				margin-top: var(--sp2x);
			}
		}

		.f-menu-container .fm-items-wrap .f-menu-item {
			margin-bottom: var(--sp3x);
		}

		.footer-fake-bg {
			top: calc(var(--fPadTop) * 2) !important;
		}
	}
`;

export default FooterStyle;
